import { type ReactNode } from 'react';
import { ToastContainer } from '@adv-frontend/toast';
import { AsyncProcessMonitorAsync } from '#features/AsyncProcessMonitor';
import { FlagControllerAsync } from '#features/FlagController';

interface AppShellProviderProps {
    children: ReactNode;
}

export function AppShellProvider({ children }: AppShellProviderProps) {
    return (
        <>
            <ToastContainer />
            <FlagControllerAsync />
            <AsyncProcessMonitorAsync />
            {children}
        </>
    );
}
